<script lang="ts" setup>
withDefaults(
  defineProps<{
    index: number
  }>(),
  {},
)

const activeIndex = inject('activeIndex')
</script>

<template>
  <div class="tab" :is-active="index === activeIndex" :index="index">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.tab {
  display: none;

  &[is-active='true'] {
    display: block;
  }
}
</style>
